export const PAGES = {
  INSTRUCTIONS: 'INSTRUCTIONS',
  SETTING: 'SETTING',
  WORKOUT: 'WORKOUT',
}
